import { render } from "./complaint_details.vue?vue&type=template&id=2993b402"
import script from "./complaint_details.vue?vue&type=script&lang=js"
export * from "./complaint_details.vue?vue&type=script&lang=js"

import "./complaint_details.vue?vue&type=style&index=0&id=2993b402&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__